<div class="bubble-container">
    <button
    data-cy="dashboard-custom-page-filter-badge"
        *ngFor="let option of options"
    (click)="toggleSelected(option)"
        [ngClass]="{
            primary: isSelected(option),
            border: !isSelected(option)
        }"
        class="caption bubble-option"
    >
        {{ extractLabelFn(option) }}
    </button>
    <div
        *ngIf="dashboardSelector"
        class="close-wrapper highlighted-text"
        (click)="clearSelection()"
    >
        <mat-icon svgIcon="cancel-close"></mat-icon>
        <span> {{ "dashboard.forms.add-panel.labels.clear" | translate }}</span>
    </div>
</div>
